<template>
    <header class="header">
        <div class="hd-top">
            <div class="wp">
                <div class="logo-group ">
                    <!--                    <a :href="hdData.headNameHyperlink" class="logo">-->
                    <!--                        <img :src="hdData.headLogOne ? hdData.headLogOne : logo1" alt="">-->
                    <!--                    </a>-->
                    <a :href="hdData.headNameTwoHyperlink" class="logo">
                        <img :src="hdData.headLogTwo ? hdData.headLogTwo : logo2" alt="">
                    </a>
                </div>
                <div class="tel-mod">
                    <p>
                        <i></i>
                        <span>{{ hdData.headPhone }}</span>
                    </p>
                    <em>24小时服务热线</em>
                </div>
                <div class="menuBtn"
                     :class="{open:showNav}"
                     @click="clickMenuBtn"></div>
            </div>
        </div>
        <div class="hd-bot" :class="{show:showNav}">
            <div class="wp">
                <div class="nav">
                    <div class="item" :class="{active:name === 'home'}">
                        <a href="#/" class="item-tit">
                            首页
                        </a>
                    </div>
                    <div class="item" :class="{active:name === 'enclave'}">
                        <a href="#/enclave" class="item-tit">
                            内蒙古（北京）人才科创中心
                        </a>

                    </div>
                    <div class="item" :class="{active:name === 'mengkeju'}">
                        <a href="#/mengkeju" class="item-tit">
                            科技兴蒙创新服务平台
                        </a>
                    </div>
                    <div class="item" :class="{active:name === 'talent' || name === 'incubator'}">
                        <a href="javascript:;" class="item-tit">
                            主要业务
                        </a>
                        <div class="sub-list-wrap">
                            <div class="sub-list">
                                <div class="item2">
                                    <a :href="'#/talent?tab='+0" >
                                        人才引进
                                    </a>
                                </div>
                                <div class="item2">
                                    <a :href="'#/talent?tab='+1" >
                                        成果转化
                                    </a>
                                </div>
                                <div class="item2">
                                    <a :href="'#/talent?tab='+2">
                                        企业孵化
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="item" :class="{active:name === 'news'}">
                        <a href="#/news" class="item-tit">
                            新闻资讯
                        </a>
                    </div>
                    <div class="item" :class="{active:name === 'aboutUs'}">
                        <a href="#/aboutUs" class="item-tit">
                            关于我们
                        </a>
                    </div>
                </div>
                <div class="search">
                    <input type="text" v-model="search" @keyup.enter="toSearch" placeholder="输入新闻名称进行搜索">
                    <i @click="toSearch"></i>
                </div>
            </div>
        </div>
    </header>
</template>
<script>
import {WOW} from "wowjs";
import {headerFooterApi, talentComBoxApi, worldComBoxApi} from "@/api";
import Bus from "@/bus";

export default {
    name: "PageHeader",
    data() {
        return {
            name: '',
            showNav: false,
            hdData: {},
            logo1: require('@/assets/images/logo1.svg'),
            logo2: require('@/assets/images/logo2.svg'),
            enclave: [],
            talent: [],
            search: ''
        }
    },
    mounted() {
        new WOW({live: false}).init()
        this.name = this.$route.name;


        headerFooterApi().then(res => {
            if (res.code === 200) {
                this.hdData = res.data
            }
        })

        worldComBoxApi().then(res => {
            if (res.code === 200) {
                this.enclave = res.data
            }
        })
        talentComBoxApi({level: 1}).then(res => {
            if (res.code === 200) {
                this.talent = res.data;
            }
        })
    },
    methods: {
        toSearch: function () {
            this.$router.push({name:'news',params:{search:this.search}})
            Bus.$emit('search', this.search)
        },
        clickMenuBtn: function () {
            this.showNav = !this.showNav
        }
    },
    watch: {
        '$route'(val) {
            this.name = val.name;
            this.showNav = false
        }
    }
}
</script>


<style scoped lang="scss">

</style>
